// extracted by mini-css-extract-plugin
export var label = "_bo-2";
export var slideContainer = "_bo-0";
export var slider = "_bo-1";